// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { SimManagementAreaId } from './SimManagementAreaId'
import { SimManagementAreaNavigation } from './SimManagementAreaNavigation'
import { SimManagementAreaRoutes } from './SimManagementAreaRoutes'

const LazySimManagementComponent = lazy(() => import('./SimManagementArea'))

const SimManagementComponent = () => (
  <SuspenseLoadingWrapper>
    <LazySimManagementComponent />
  </SuspenseLoadingWrapper>
)

export const SimManagementArea = {
  id: SimManagementAreaId,
  requiredRight: BoumRight.AREA_SIM_MANAGEMENT,
  NavigationComponent: SimManagementAreaNavigation,
  route: {
    path: SimManagementAreaRoutes.route,
    component: SimManagementComponent,
  },
}
